export const GET_DEBIT_NOTES = 'GET_DEBIT_NOTES';
export const GET_DEBIT_NOTE = 'GET_DEBIT_NOTE';
export const ADD_DEBIT_NOTE = 'ADD_DEBIT_NOTE';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const EDIT_DEBIT_NOTE = 'EDIT_DEBIT_NOTE';
export const SET_SEARCH_DEBIT = 'SET_SEARCH_DEBIT';
